import React, { useEffect, useState } from 'react';

import { LaunchFlow } from 'components/launch/launch-flow';
import { logger } from 'utils';

type LaunchContext = {
	launch: any;
	setLaunch: any;
	open: boolean;
	rootApi: string;
	rootLink: string;
	onOpen: any;
	onToggle: any;
	onUpdate: any;
	onRefresh: any;
};

const LaunchContext = React.createContext<LaunchContext>(null);

const LaunchProvider = ({ ssr, workspace, router, session, store, toast, children }) => {
	const [launch, setLaunch] = useState<any>({ status: 'draft' });
	const [view, setView] = useState('basics');
	const [open, setOpen] = useState(false);

	// Computed
	const rootApi = workspace.rootApi;
	const rootLink = workspace.rootLink;

	// Hooks
	useEffect(() => {
		return () => onRefresh();
	}, [router.asPath]);

	useEffect(() => {
		if (launch.id) logger.debug('launchContext: ', launch);
	}, [launch]);

	// Methods
	const onOpen = view => {
		setOpen(true);
		setView(view);
	};

	const onToggle = () => setOpen(!open);
	const onUpdate = data => setLaunch({ ...launch, ...data });
	const onRefresh = () => setLaunch({ status: 'draft' });

	// Render
	return (
		<LaunchContext.Provider
			value={{ launch, setLaunch, open, rootApi, rootLink, onOpen, onToggle, onUpdate, onRefresh }}>
			{children}
			<LaunchFlow model={launch} initialView={view} open={open} setOpen={setOpen} />
		</LaunchContext.Provider>
	);
};

const useLaunch = () => {
	return React.useContext(LaunchContext);
};

export { LaunchProvider, useLaunch };
